module.exports = __webpack_public_path__ + "static/media/3-5.003e3633.mp3";